<img [ngClass]="{ 'mat-card-image': isInCard }" [src]="img && img.jpg" src-fallback="/assets/img/placeholder-image.png"
  [alt]="alt" class="object-cover h-full w-full overflow-hidden" />
